import React from 'react';
import { X } from 'lucide-react';
import { useBetContext } from '../context/BetContext';
import { useI18n } from '../context/I18nContext';
import EventBets from './EventBets';
import TotalOddsDisplay from './TotalOddsDisplay';
import { InternalGroupedEvent, TotalOdd } from '../types';
import { isClosedOrSuspended,formatIsoToCustomDate } from '../utils/utils';

const EventGroup: React.FC<Props> = ({ group }) => {
  const { removeEventBets, config, eventSelected, totalOdds } = useBetContext();
  const { t } = useI18n();
  const closedOrSuspended = isClosedOrSuspended(group);
  const calculatedOdds = (eventId: string,type:string = 'odd'): number => {
    if(group.TotalOdds>0 && config.calculationResultBottom){
      return group.TotalOdds;
    }
    const odds:TotalOdd[] = totalOdds.filter(o => o.eventId.toString() == eventId.toString());
    return odds.length > 0 ? odds[0][type] : -1;
  };
  
  const getEventName = ():any=>{
    if(group.EventName.length===0){
      return (<div className="name-date-box">
        <div onClick={() => eventSelected(group.EventId.toString())}
             className="event-name text-md font-medium text-foreground">
          <span>{group.Home}</span>
          <span className="seperator">{group.Seperator}</span>
          <span>{group.Away}</span>
        </div>
        <div className="event-date">{group.EventDate}</div>
      </div>)
    }
    return <div onClick={() => eventSelected(group.EventId.toString())}
               className="event-name text-md font-medium text-foreground">
                {group.EventName}
                {group.EventDate.length > 0 && !config.calculationResultBottom && (
                      <div className="event-date">{formatIsoToCustomDate(group.EventDate)}</div>
                )}
              </div>
  }
  return (
    <div className="bet-builder-event flex relative">
        {group.FixtureId.length > 0 && (
            <div className="fixtureId">{group.FixtureId}</div>
        )}
        {closedOrSuspended && (
        <div className="event-suspend absolute top-0 left-0 right-0 text-center bg-gray-50 opacity-80 text-black text-sm h-full flex justify-center items-center font-bold rounded-t-md z-10">
          {group.Closed ? t('betBuilder.eventClosed') : t('betBuilder.eventSuspended')}
        </div>
      )}
      <div className={`grow py-[12px] relative ${closedOrSuspended ? 'opacity-80' : ''}`}>
        
        <div className="flex flex-col">

          {!config.calculationResultBottom  && (<div className="bet-builder-tag bg-[#F28110] rounded-md text-white px-[8px] text-sm mr-auto">{t('betBuilder.buildABet')} </div>)}
            
          <div className="bet-builder-info flex justify-between items-center pt-2">
            {getEventName()}
            
            <TotalOddsDisplay flash= {false}
              showArrow={false} 
              acceptOddsChange={config.acceptOddsChange}
              current={calculatedOdds(group.EventId.toString())}
              previous={calculatedOdds(group.EventId.toString(),'previouseOdd')}/>

            {/*not in the design*/}
            {/*{config.calculationResultBottom && (<span className="border border-solid border-[var(--border)] px-[6px] mr-[6px] font-bold bg-[var(--card)] ml-[4px]">{t(`betStatus.${getEnumKeyByValue(TicketEventStatus, group.EventStatus)?.toLowerCase()}` || '')}</span>)}*/}
          </div>
        </div>
        <EventBets group={group} />

        
      </div>
      {!config.calculationResultBottom && (!config.viewOnly || config.allowRemoveEvent) && (
        <button
          onClick={() => removeEventBets(group.EventId.toString())}
          className="btn-remove hover:text-danger pl-[8px] mx-[8px] w-[calc(13%-6px)] flex items-center justify-center border-l border-solid border-[color:var(--border)]"
          aria-label={`Remove all bets for ${group.EventName}`}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

interface Props {
  group: InternalGroupedEvent;
  
}

export default EventGroup;
